import React, { useEffect, useState } from "react";
import { useHistory, useParams } from "react-router-dom";
import { usePropostaVendas } from "services/api/AppWeb_PropostaVendas";
import { extrairIdOportunidade } from "services/api/CopiaProposta/post-copiar-proposta";
import { toast } from "react-toastify";
import { Skeleton, Tooltip } from "@mui/material";
import ModalCommon from "components/ModalCommon";
import * as S from "./styles";
import NavCommon from "../../components/@navHeader";
import ProductCard from "../../components/dialogCommon/templates/PropostaVendasModal/ProductCard";
import CopiarPropostaModal from "../../components/dialogCommon/templates/PropostaVendasModal/components/CopiarPropostaModal";
import * as Icon from "../../assets/iconsSVG";

export function SimuladorRepasseChaves() {
  const params: any = useParams();
  const history = useHistory();
  const [fluxoNovo, setFluxoNovo] = useState<boolean>(true);
  const [isCopiarPropostaModalOpen, setIsCopiarPropostaModalOpen] =
    useState(false);
  const [propostaCopiada, setPropostaCopiada] = useState(false);
  const [idOportunidadeCopiada, setIdOportunidadeCopiada] = useState<
    string | null
  >(null);

  // A cópia só vale na criação da proposta: uma vez salva (fluxo aberto em modo
  // de edição), sobrescrever o fluxo deixa de ser permitido.
  const podeCopiarProposta = params.action !== "editable";

  const {
    data,
    refetch: refetchProposta,
    isLoading,
    isRefetching,
  } = usePropostaVendas({
    queryKey: "proposta_vendas",
    idUnidade: params.idUnidade,
    idLeadCorretor: params.idLeadCorretor,
    fluxoNovo,
  });

  // Modificar os dados para garantir que a propriedade editável seja sempre true
  // const prepareDataForEdit = (data: any) => {
  //   if (!data) return null;

  //   return {
  //     ...data,
  //     data: {
  //       ...data.data,
  //       editavel: true,
  //     },
  //   };
  // };

  useEffect(() => {
    if (data) {
      setFluxoNovo(false);
    }
  }, [data]);

  useEffect(() => {
    if (params.action === "editable") {
      refetchProposta();
    }
  }, []);

  const handleRefetch = async (novoFluxo: boolean) => {
    await setFluxoNovo(novoFluxo);

    refetchProposta();
  };

  const handleBack = () => {
    history.goBack();
    localStorage.setItem("@sell.it/previousScreen", window.location.href);
  };

  return (
    <>
      <NavCommon
        breadcrumbs={[
          {
            path: `/lead-detail/${params.idLeadCorretor}`,
            name:
              params.action === "editable" ? `Detalhes do lead` : `Carteira`,
          },
          {
            path: `/lead-detail/${params.idLeadCorretor}${
              params.action === "editable"
                ? `/proposition-detail/${params.numeroCotacao}`
                : ""
            }`,
            name:
              params.action === "editable" ? "Propostas" : "Detalhes do lead",
          },
          {
            path: `/lead-detail/${params.idLeadCorretor}/repasse-chaves/${
              params.idUnidade
            }/${params.idOportunidade}/${params.numeroCotacao}${
              params.action ? `/${params.action}` : ""
            }`,
            name: "Simulador Repasse Chaves",
          },
        ]}
        showButtonNew
        onBack={handleBack}
        open
        onChangeActionNew={undefined}
      />
      <S.Container>
        <S.BodyContainer>
          <S.TitleRow>
            <S.Title>Proposta de vendas</S.Title>
            <S.Row>
              <Tooltip
                title={
                  podeCopiarProposta
                    ? "Copie o fluxo de pagamento de uma proposta já existente. Os percentuais das séries são mantidos e os valores recalculados para esta unidade."
                    : "A cópia de proposta só está disponível durante a criação, antes de salvar o fluxo."
                }
              >
                <S.InfoIconWrapper>
                  <Icon.InfoIcon />
                </S.InfoIconWrapper>
              </Tooltip>
              <S.CopiarPropostaButton
                disabled={!podeCopiarProposta || isLoading}
                onClick={() => setIsCopiarPropostaModalOpen(true)}
              >
                Copiar Proposta
              </S.CopiarPropostaButton>
            </S.Row>
          </S.TitleRow>

          {isLoading ? (
            <Skeleton variant="rectangular" height={1000} />
          ) : (
            <ProductCard
              dataInfoHeader={data}
              data={data}
              unidadeDataReal={data}
              onClose={handleBack}
              refetch={() => handleRefetch(false)}
              idLead={params.idLead}
              leadProducts={{
                label: "",
                value: "",
                idLeadCorretor: params.idLeadCorretor,
              }}
              isRefetching={isRefetching}
              idOportunidadeCopiada={
                propostaCopiada
                  ? extrairIdOportunidade(data) || idOportunidadeCopiada
                  : null
              }
            />
          )}
        </S.BodyContainer>
      </S.Container>

      <ModalCommon
        open={isCopiarPropostaModalOpen}
        setOpenModal={setIsCopiarPropostaModalOpen}
        onClose={() => setIsCopiarPropostaModalOpen(false)}
      >
        <CopiarPropostaModal
          onClose={() => setIsCopiarPropostaModalOpen(false)}
          idUnidade={params.idUnidade}
          idLeadCorretor={params.idLeadCorretor}
          dataEntrega={data?.data?.dataEntregaEmpreendimento}
          refetch={() => handleRefetch(false)}
          onPropostaCopiada={(idOportunidade) => {
            setPropostaCopiada(true);
            if (idOportunidade) setIdOportunidadeCopiada(idOportunidade);
          }}
        />
      </ModalCommon>
    </>
  );
}
